module.exports = "https://zhaopin-chat.epta.org.cn/img/mute.fdf21a75.svg";